// extracted by mini-css-extract-plugin
export var btnUp = "ButtonUp-module--btn-up--62406";